<template>
  <div class="new-layout">
    <div class="new-layout-bg">
      <div class="new-content" >
        <div  class="title">步履山海，恒久为爱：地平线计划2025-2026公益纪实</div>
        <div style="color: rgba(80, 80, 80, 0.7);margin-top: 6px">2026年01月05日 16:38 北京</div>
        <div class="content">
          <div class="big-ds">
            一、地平线计划初衷
          </div>
          <div class="ds-ct">
            “地平线计划”的初衷是汇聚一群热爱运动、热衷公益的企业家和爱心人士发起，以“超越极限的脚步，永不落山的公益”为信念，将奔跑者的坚韧与公益行动相结合。将挑战自我、坚韧不拔的运动精神（如马拉松、戈壁挑战）转化为持久的公益力量。我们旨在通过“运动+公益”的独特模式，突破地域与资源的限制，携手点亮乡村、温暖教育、持续行动，如同追逐地平线一样，始终向着远方和希望前行，让温暖与光明持续照耀每一处需要的地方。
          </div>
          <img class="new-icon" src="@/assets/news_image1.jpeg">

          <div class="big-ds">
            二、步履不停，温暖随行：地平线计划2025公益行动纪实
          </div>
          <div class="ds-ct">
            1.点亮乡村照明：2025年5月5号在四川大凉山彝族自治州美姑县佐戈依达村捐赠安装120盏太阳能路灯，解决2200名村民夜间出行难题，并走访塔哈村小学捐赠运动及学习物资。
          </div>
          <img class="new-icon" src="@/assets/new3_img1.png">

          <div class="ds-ct">
            2.温暖校园生活：2025年7月为塔哈村小学提供专项爱心早餐善款，让孩子们每日吃上热馒头和鸡蛋，改善营养条件。
          </div>
          <img class="new-icon" src="@/assets/new3_img2.png">
          <div class="ds-ct">
            3.奔跑传递能量：2025年4月20号参与长沙马拉松等活动，以奔跑形式倡导公益，凝聚社会爱心力量。
          </div>
          <img class="new-icon" src="@/assets/new3_img3.jpg">
          <img class="new-icon" src="@/assets/new3_img4.jpg">
          <div class="ds-ct">
            4.扩展光明行动：2025年12月30号向四川大凉山彝族自治州甘洛县沙岱乡捐赠150盏太阳能灯，进一步覆盖偏远山区，提升村民夜间安全与生活品质。
          </div>
          <img class="new-icon" src="@/assets/new3_img5.png">
          <img class="new-icon" src="@/assets/new3_img6.png">

          <div class="big-ds">
            三、地平线公益计划2026年香港麦理浩径徒步活动已顺利收官。
          </div>
          <img class="new-icon" src="@/assets/new3_img7.jpg">
          <div class="ds-ct">
            这次地平线公益计划的香港之行，是 “运动 + 公益” 理念的一次落地实践：2026 年1月5号，计划里的爱心企业家们奔赴香港，挑战了麦理浩径第二段路线，还打卡了破边洲，在破边洲感受了海蚀柱的磅礴气势，并徒步穿越被誉为“亚洲最美步道”之一的麦理浩径第二段，领略了西湾、浪茄湾的山海胜景。
          </div>
          <img class="new-icon" src="@/assets/new3_img8.jpg">

          <div class="ds-ct">
            这不仅是一次体能和意志的挑战，更是一场行走的公益倡导。我们以脚步丈量山海，将徒步中激发出的毅力与团结，转化为支持乡村教育、点亮远方希望的实际力量，再次践行了“超越极限的脚步，永不落山的公益”的初心。
          </div>
          <img class="new-icon" src="@/assets/new3_img9.jpg">

          <div class="ds-ct">
            步履不停，为爱前行。期待与您一起，走向下一个地平线。
          </div>
          <img class="new-icon" src="@/assets/new3_img10.jpg">

        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };

  },

  methods: {


    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
    position: relative;

  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-direction: column;


    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
      .big-ds{
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: justify;
        font-weight: bold;
        font-size: 18px;
        color: #035cff;
      }

      .ds-ct {
        text-align: justify;
      }


      .new-icon {
        text-align: justify;
        width: 80%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
    }

  }


}
</style>
